var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMaimu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 44,
    viewBox: "0 0 94 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.88892,
    width: 84.001,
    height: 34.2224,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 84.001,
    height: 4.88891,
    fill: "#BDE9B0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 39.1111,
    width: 84.001,
    height: 4.88891,
    fill: "#BDE9B0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 4.88916,
    width: 5.00006,
    height: 34.2224,
    fill: "#BDE9B0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 4.88892,
    width: 5.00006,
    height: 34.2224,
    fill: "#BDE9B0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22.489,
    width: 84.001,
    height: 16.6223,
    fill: "#BDE9B0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 35.2002,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73.001,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.002,
    y: 35.2002,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 35.2002,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 30.3115,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 30.3115,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81.001,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 30.3115,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 30.3115,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 30.3115,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 35.2002,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 7.82227,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 69.001,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 77.002,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 15.6445,
    width: 4.00005,
    height: 3.91113,
    fill: "#BDE9B0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00098,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 16.999,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 28.999,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 24.999,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 20.999,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 45.001,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 41.002,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 37.002,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 33.002,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 65.001,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 22.489,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 81.001,
    y: 18.5779,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 26.4001,
    width: 4.00005,
    height: 3.91113,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMaimu);
export default __webpack_public_path__ + "static/media/GreenMaimu.f1f836ca5a1ac9a983c3230805ac7d37.svg";
export { ForwardRef as ReactComponent };